import type { SuperbarTheme } from './theme';

export const superbarDarkTheme: SuperbarTheme = {
  mode: 'liquidGlass',
  colors: {
    surface: {
      // You currently use transparent shell in the main panel + rgba black for form/closed shell
      appBg: 'transparent',
      appBgMinimized: 'rgba(0,0,0,0.50)',
      systemMessageBg: '#0F0F10',
      notificationBg: '#0F0F10',
    },
    ink: {
      primary: '#FFFFFF',
      secondary: '#3A3A3A',
      tertiary: '#A0A0A0',
      inverse: '#000000',
      muted: 'rgba(255,255,255,0.5)',
      disabled: '#CCCCCC',
    },
    border: {
      shell: '#D5D5D5', // your container still uses this border color currently
      systemMessageBottom: '#3A3A3A',
    },
    selection: {
      bg: '#FFFFFF',
      fg: '#000000',
    },
  },
  shadows: {
    shell: '0px 0px 10px rgba(0,0,0,0.15), 4px 4px 60px rgba(0,0,0,0.25)',
    minimizedShell: '0 0 20px rgba(0,0,0,0.2)',
    systemMessageCloseButton: '0 0 10px rgba(0,0,0,0.30)',
    notification: '0px 4px 16px rgba(0, 0, 0, 0.24)',
  },
  radii: {
    panel: '28px',
    minimizedPanelTop: '28px',
    minimizedPanel: '20px',
    pillButton: '25px',
    round: '100%',
  },
  components: {
    chatShell: {
      borderColor: '#D5D5D5',
      shadow: '0px 0px 10px rgba(0,0,0,0.15), 4px 4px 60px rgba(0,0,0,0.25)',
      background: 'transparent',
    },
    chatShellClosed: {
      background: 'rgba(0,0,0,0.50)',
      shadow: '0 0 20px rgba(0,0,0,0.2)',
      radius: '20px',
    },
    systemMessage: {
      background: '#0F0F10',
      borderBottomColor: '#3A3A3A',
      radiusTop: '28px',
    },
    inputForm: {
      background: 'rgba(0,0,0,0.50)',
      radiusTopWhenNoSystemMessage: '42px',
      radiusBottom: '42px',
      backdropFilter: 'saturate(1.8) blur(20px)',
      boxShadow:
        '0 0 10px 0 rgba(0, 0, 0, 0.15), 4px 4px 60px 0 rgba(0, 0, 0, 0.25)',
    },
    menu: {
      iconColor: 'rgba(255, 255, 255, 0.5)',
      textColor: '#FFFFFF',
      itemHoverBackground: 'rgba(255, 255, 255, 0.1)', // white/10
      poweredBy: {
        iconBgColor: 'rgba(255, 255, 255, 0.5)',
        iconColor: '#000000',
        dividerColor: '#4A4A4A',
      },
      closeButton: {
        background: '#0F0F10',
        borderColor: '#3A3A3A',
        icon: '#FFFFFF',
        iconHover: '#000000',
        backgroundHover: '#FFFFFF',
      },
    },
    aiFilters: {
      titleColor: '#FFFFFF',
      nextQuestionButton: {
        background: 'rgba(255, 255, 255, 0.1)',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        textColor: 'rgba(255, 255, 255, 0.6)',
        hoverBackground: 'rgba(255, 255, 255, 0.2)',
      },
      filter: {
        background: 'rgba(255, 255, 255, 0.1)',
        textColor: '#FFFFFF',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        hoverBackground: 'rgba(255, 255, 255, 0.2)',
        clearIconColor: 'rgba(255, 255, 255, 0.6)',
        clearIconHoverColor: '#FFFFFF',
      },
    },
    loader: {
      color: '255, 255, 255',
      opacity: '0.8',
      stableOpacity: 'caddietw-opacity-1',
    },
    inputText: {
      text: 'rgba(255,255,255,0.9)',
      textLoading: '#FFFFFF',
      selectionBg: '#FFFFFF',
      selectionText: '#000000',
      textShadow: '0px 1px 0px rgb(255 255 255 / 0.05)',
    },
    placeholder: {
      text: '#FFFFFF',
      className: 'placeholder:caddietw-text-white/50',
    },
    assistantMessage: {
      text: '#FFFFFF',
      ctaButton: {
        background: '#FFFFFF',
        text: '#000000',
        hoverBackground: '#E5E7EB', // matches your "hover gray-200" intent
      },
      closeButton: {
        background: '#0F0F10',
        borderColor: '#3A3A3A',
        icon: '#FFFFFF',
        iconHover: '#000000',
        backgroundHover: '#FFFFFF',
      },
    },
    notification: {
      root: {
        background: '#0F0F10',
        border: 'none',
        radius: '10px',
        padding: '14px 12px',
        shadow: '0px 4px 16px rgba(0, 0, 0, 0.24)',
      },
      title: {
        color: '#FFFFFF',
        fontWeight: '400',
      },
      description: {
        color: '#A0A0A0',
      },
      closeButton: {
        color: '#A0A0A0',
        hoverBg: 'rgba(255,255,255,0.05)',
        hoverColor: '#A0A0A0',
      },
    },
  },
};
